import React, { useEffect, useState } from "react";
import {
    DKLabel,
    DKButton,
    showToast,
    TOAST_TYPE,
    showLoader,
    removeLoader,
    DKIcons,
    DKDateRangePicker,
    DKInput,
    INPUT_TYPE,
    INPUT_VIEW_DIRECTION
  } from "deskera-ui-library";
import Popup from "../common/Popup";
import { useTranslation } from "react-i18next";
import { getFileNameFromContentDisposition } from "../../managers/common/CommonUtil";
import { saveAs } from 'file-saver';
import AttendanceService from "../../services/AttendanceService";
import { DATE_FORMAT, FILE_TYPE } from "../../constants/Constant";
import moment from "moment";
import Utility from "../../utility/Utility";
import i18next from "i18next";

const exportTypes = [
    {
        title: i18next.t('DETAILED_REPORT'),
        type: 'detail'
    },
    {
        title: i18next.t('SUMMARY_REPORT'),
        type: 'summary'
    },
    {
        title: i18next.t('OVERTIME_REPORT'),
        type: 'overtime'
    }
];

export const MONTHS = [
    { value: 1, label: 'January' },
    { value: 2, label: 'February' },
    { value: 3, label: 'March' },
    { value: 4, label: 'April' },
    { value: 5, label: 'May' },
    { value: 6, label: 'June' },
    { value: 7, label: 'July' },
    { value: 8, label: 'August' },
    { value: 9, label: 'September' },
    { value: 10, label: 'October' },
    { value: 11, label: 'November' },
    { value: 12, label: 'December' }
];

function ExportAttendancePopup(props) {
    const { t, i18n } = useTranslation();

    const [count, updateCount] = useState(1);
    const [selectedIamUserIds, setSelectedIamUserIDs] = useState([]);

    const [type, setType] = useState(exportTypes[0]);
    const [showDateRangePicker, setShowDateRangePicker] = useState(false);
    const [fromDate, setFromDate] = useState(moment().startOf("month").startOf("day"));
    const [toDate, setToDate] = useState(moment().endOf("month").endOf("day"));

    useEffect(() => {
    }, []);

    useEffect(()=>{
        if(props.attendanceData) {
            let selectedRow = props.attendanceData?.rowData?.filter(row=>row.selected) || []
            let iamUserIds = selectedRow && selectedRow.length != 0 ? (selectedRow.map(d=>d.data.iamUserId)) : []
            setSelectedIamUserIDs(iamUserIds)
        }
    },[props])

    const forceUpdate = () => {
        updateCount(count + 1);
    }

    const downloadAttendanceReport = () => {
        if (Utility.isEmpty(type)) {
            return;
        }

        const params = {
            fileFormat: FILE_TYPE.XLSX.toUpperCase(),
            ids: selectedIamUserIds,
            type: type.type,
            fromDate: fromDate.format("YYYY-MM-DD"),
            toDate: toDate.format("YYYY-MM-DD")
        }
        
        if (AttendanceService.apiTeamConfig.filter) {
            params.designation = AttendanceService.apiTeamConfig.filter;
        }

        if (AttendanceService.apiTeamConfig.shift) {
            params.shift = AttendanceService.apiTeamConfig.shift;
        }

        showLoader();
        AttendanceService.exportAttendanceReport(params).then(
            (response) => {
                removeLoader();
                const fileName = getFileNameFromContentDisposition(response.headers['content-disposition']);
                saveAs(response.data, fileName);
                props.onClose();
            }, (error) => {
                removeLoader();
                showToast("Internal Server Error", TOAST_TYPE.FAILURE);
            }
        );
    }

    const getDatePickerTitle = () => {
        return `${Utility.formatDate(fromDate.format(DATE_FORMAT.IND), DATE_FORMAT.IND)} - ${Utility.formatDate(toDate.format(DATE_FORMAT.IND), DATE_FORMAT.IND)}`;
    }

    const renderDateRangePicker = () => {
        return (
            <div className="position-absolute bg-white z-index-6 rounded">
                <DKDateRangePicker
                    className="border shadow "
                    color={'rgb(0, 102, 65)'}
                    startDate={fromDate.toDate()}
                    selectedStartDate={fromDate.toDate()}
                    selectedEndDate={toDate.toDate()}
                    onSelectDateRange={(startDate, endDate) => {
                        if (startDate && endDate) {
                            setFromDate(moment(startDate).startOf("day"));
                            setToDate(moment(endDate).endOf("day"));
                            setShowDateRangePicker(false);
                        }
                    }}
                    onClose={() => {
                        setShowDateRangePicker(false);
                    }}
                />
            </div>
        );
    }

    return (
        <Popup popupClass={"popup-overflow"} onClose={() => props.onClose() }>
            <div>
                <div className="row">
                    <DKLabel
                        text={t("EXPORT_ATTENDANCE_DETAILS")}
                        className="fw-m fs-l mb-xl "
                    />
                </div>
                {showDateRangePicker && renderDateRangePicker()}
                <div className="row justify-content-between">
                    <div style={{ width: "48%" }}>
                        <DKLabel className="pb-xs" text={`${t("Type")}`} />
                        <DKInput
                            type={INPUT_TYPE.DROPDOWN}
                            direction={INPUT_VIEW_DIRECTION.VERTICAL}
                            displayKey="title"
                            dropdownConfig={{
                                data: exportTypes,
                                renderer: (i, item) => item.title,
                                onSelect: (i, value) => {
                                    setType(value);
                                }
                            }}
                            value={type}
                            required={true}
                            onChange={() => { }}
                        />
                    </div>
                    <div>
                        <DKLabel className="pb-xs" text={`${t("Select Date Range")}`} />
                        <div className="d-flex">
                            <DKButton
                                className="bg-gray1 border-radius-s position-relative"
                                style={{ padding: "10px 14px" }}
                                title={getDatePickerTitle()}
                                icon={DKIcons.ic_calendar}
                                onClick={() => {
                                    setShowDateRangePicker(true);
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="row justify-content-end mt-xl">
                    <DKButton
                        title="Cancel"
                        className="bg-gray1 mr-r"
                        onClick={() => props.onClose() }
                    />
                    <DKButton
                        title="Export"
                        className="bg-app text-white"
                        onClick={() => {
                            downloadAttendanceReport();
                        }}
                    />
                </div>
            </div>
        </Popup>
    );
}

export default ExportAttendancePopup;
